<template>
 <Header></Header>
  <div><el-image class="tbtp" :src="cd_dt"></el-image></div>

  <div v-if="yz!=null">
    <div class="title">椰棕床褥</div>
    <div class="subtitle">可定制規格尺寸</div>
    <el-scrollbar>
      <ul class="infinite-list" style="height: 150px; white-space: nowrap">
        <li v-for="item of yz" :key="item.index" class="infinite-list-item"  @click="openBox(item.prod_sn)">
          <el-image class="dl-tp" :src="item.url"></el-image>
          <div class="dl-wz">{{ item.prod_des }}</div>
        </li>
      </ul>
    </el-scrollbar>
  </div>

  <div v-if="clj!=null" class="clearfix">
    <div class="title">超力膠床褥</div>
    <div class="subtitle">可定制規格尺寸</div>
    <div class="zp" v-for="item of clj" :key="item.index" wx:key="index"  @click="openBox(item.prod_sn)">
      <el-image :src="item.url"></el-image>
      <div class="zpdes">{{ item.prod_des }}</div>
    </div>
  </div>

  <div v-if="th!=null" class="clearfix">
    <div class="title">彈簧床褥</div>
    <div class="subtitle">可定制規格尺寸</div>
    <div class="zp" v-for="item of th" :key="item.index" wx:key="index"  @click="openBox(item.prod_sn)">
      <el-image :src="item.url"></el-image>
      <div class="zpdes">{{ item.prod_des }}</div>
    </div>
  </div>
  <Footer></Footer>
  <Box
  :dialogVisible="box.dialogVisible"
  :goods_id="box.goods_id"
  @close="boxClose"
></Box>
</template>

<script>
import Footer from "@/components/Footer_m";
import Header from "@/components/Header_m";
import Box from "@/components/Box_m";
export default {
  name: "Contact",
  data() {
    return {
      cd_dt: "https://nicedream.top:8202/gw_lmm/cd1.jpg",
      yz:[],
      clj:[],
      th:[],
      box: {
        dialogVisible: false,
        goods_id: "",
      },
      // yz: [
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/yz/1.jpg",
      //     prod_des: "椰棕保健床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/yz/2.jpg",
      //     prod_des: "心心高級混凝保健床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/yz/3.jpg",
      //     prod_des: "美健高级椰棕床褥",
      //   },
      // ],
      // clj: [
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/clj/1.jpg",
      //     prod_des: "蘆薈波浪膠舒適床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/clj/2.jpg",
      //     prod_des: "蘆薈寶健康膠床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/clj/3.jpg",
      //     prod_des: "水晶膠床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/clj/4.jpg",
      //     prod_des: "藍網膠床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/clj/5.jpg",
      //     prod_des: "灰網膠床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/clj/6.jpg",
      //     prod_des: "紅網膠床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/clj/7.jpg",
      //     prod_des: "杏網膠床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/clj/8.jpg",
      //     prod_des: "金鑽雙面健康床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/clj/9.jpg",
      //     prod_des: "美的夢豪華膠床褥",
      //   },
      // ],
      // th: [
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/th/1.jpg",
      //     prod_des: "美的夢ISO9001護脊型床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/th/2.jpg",
      //     prod_des: "銀至尊",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/th/3.jpg",
      //     prod_des: "兒護型袋裝床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/th/4.jpg",
      //     prod_des: "幸運星輕型舒適彈弓床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/th/5.jpg",
      //     prod_des: "金至尊中量级床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/th/6.jpg",
      //     prod_des: "乳膠彈簧床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/th/7.jpg",
      //     prod_des: "獨立袋裝彈簧床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/th/8.jpg",
      //     prod_des: "超级型三面床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/th/9.jpg",
      //     prod_des: "舒壓型彈簧床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/th/10.jpg",
      //     prod_des: "美的夢特硬型床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/th/11.jpg",
      //     prod_des: "美的夢之寶",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/th/12.jpg",
      //     prod_des: "金至尊(新版)",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/th/13.jpg",
      //     prod_des: "蘆薈舒適健康床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/th/14.jpg",
      //     prod_des: "蘆薈三面護脊床褥",
      //   },
      //   {
      //     url: "https://nicedream.top:8202/gw_lmm/cd/th/15.jpg",
      //     prod_des: "蘆薈智能恒溫床褥",
      //   },
      // ],
    };
  },
  components: { Footer, Header,Box },
    created(){
    if(sessionStorage.getItem("company_sn")!=null){
      this.company_sn=sessionStorage.getItem("company_sn")
      this.queryProdYZ()
      this.queryProdCLJ()
      this.queryProdTH()
    }
  },
    methods:{
    openBox(goods_id) {
      this.box.dialogVisible = true;
      this.box.goods_id = goods_id;
    },
    // 弹窗的搜索关闭
    boxClose(val) {
      this.box.dialogVisible = val;
    },
    // 查询推荐货品
    queryProdYZ() {
      this.$api.queryprod({company_sn:this.company_sn,category_sn:"A001",high:0}).then(
        res => {
          if (res.state == 10000) {
            this.yz=res.data.prod
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
    // 查询推荐货品
    queryProdCLJ() {
      this.$api.queryprod({company_sn:this.company_sn,category_sn:"A002",high:0}).then(
        res => {
          if (res.state == 10000) {
            this.clj=res.data.prod
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
        // 查询推荐货品
    queryProdTH() {
      this.$api.queryprod({company_sn:this.company_sn,category_sn:"A003",high:0}).then(
        res => {
          if (res.state == 10000) {
            this.th=res.data.prod
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
  }

};
</script>

<style scoped>
.tbtp {
  height: 150px;
}
.title {
  margin-top: 25px;
  font-size: 22px;
  color: rgb(51, 51, 51);
}
.subtitle {
  font-size: 12px;
  line-height: 25px;
  color: rgb(51, 51, 51);
}

/* 單輪 */
.infinite-list {
  height: 180px;
  padding-left: 5px !important;
}
.infinite-list-item {
  display: inline-block;
  width: 200px;
  height: 150px;
  margin-right: 10px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}
.dl-tp {
  width: 200px;
  height: 115px;
}
.dl-wz {
  font-size: 13px;
}

/* 展示 */
.zp {
  float: left;
  width: 44vw;
  height: 50vw;
  margin-left: 2.8vw;
  margin-top: 4vw;
  border-radius: 5px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
}
.zp .el-image {
  width: 44vw;
  height: 40vw;
}
.zpdes {
  font-size: 13px;
}
</style>